import React from "react";
import PropTypes from "prop-types";
import util from "../util/util";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";
import InaccessibleLink from "../shim/inaccessible-link";

export default function UserListTable(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover">
        <colgroup>
          <col style={{ width: `1%` }}></col>
          <col style={{ width: `30%` }}></col>
          <col style={{ width: `30%` }}></col>
          <col style={{ width: `15%` }}></col>
          <col style={{ width: `12%` }}></col>
          <col style={{ width: `12%` }}></col>
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Activated</th>
            <th>Remove User</th>
          </tr>
        </thead>
        <tbody>
          {props.users === false ? (
            <tr>
              <td>
                <strong>0</strong>
              </td>
              <td colSpan="5">{util.zeroUsersMessage}</td>
            </tr>
          ) : null}

          {props.users && props.users.length === 0 ? (
            <tr>
              <td colSpan="6">
                <LoadingIndicatorText />
              </td>
            </tr>
          ) : null}

          {props.users && props.users.length
            ? props.users.map((user, index) => {
                return index < util.userResultsPerPage ? (
                  <tr key={index}>
                    <td>
                      <strong>
                        {util.returnLineNumber(
                          props.currentPage,
                          util.userResultsPerPage,
                          index
                        )}
                      </strong>
                    </td>
                    <td>{user.user.name || <em>N/A</em>}</td>
                    <td>{user.user.email || <em>N/A</em>}</td>
                    <td>{user.group ? user.group.name : <em>N/A</em>}</td>
                    <td>{user.activated ? `Yes` : `No`}</td>
                    <td>
                      <InaccessibleLink
                        className="text-danger"
                        onClick={() => props.onClickDeleteUser(user)}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                        Remove
                      </InaccessibleLink>
                    </td>
                  </tr>
                ) : null;
              })
            : null}
        </tbody>
      </table>
    </div>
  );
}

UserListTable.propTypes = {
  currentPage: PropTypes.number, // used to calc the # in the TABLE;
  onClickDeleteUser: PropTypes.func, // remove user from station;
  users: PropTypes.oneOfType([
    // user data to display;
    PropTypes.array,
    PropTypes.bool
  ])
};
